import React from 'react';
import { Widget } from '../layouts/Widget';
import LayoutInput from '../layouts/LayoutInput.mjs';
import '../../../scss/widgets/ImageWidget.scss'; // Import the SCSS file

/**
 * ImageWidget
 * 
 * Displays an image with an optional link.
 */

const options = [
  new LayoutInput('imageUrl', 'text', 'Image URL').setRequired(),
  new LayoutInput('altText', 'text', 'Alt Text', 'Image'),
  new LayoutInput('width', 'text', 'Width', '100%'), // Image width, applied to img tag
  new LayoutInput('height', 'text', 'Height', 'auto'), // This option seems unused for img height in original
  new LayoutInput('objectFit', 'dropdown', 'Image Fit', 'cover', '', ['cover', 'contain', 'fill', 'scale-down', 'none']),
  new LayoutInput('linkUrl', 'text', 'Link URL (optional)').setAdvanced(true),
  new LayoutInput('openInNewTab', 'checkbox', 'Open Link in New Tab', true).setAdvanced(true),
  // Responsive width options for the container might be better handled by GridLayout directly or a different approach
  // For now, removing these from ImageWidget specific options as they were unused in render
  // new LayoutInput('xl', 'text', 'XL', '100%'),
  // new LayoutInput('lg', 'text', 'LG', '100%'),
  // new LayoutInput('md', 'text', 'MD', '100%'),
  // new LayoutInput('sm', 'text', 'SM', '100%'),
  // new LayoutInput('xs', 'text', 'XS', '100%')
];

// eslint-disable-next-line no-unused-vars
const render = (guideData, options, props) => {
  const { 
    imageUrl,
    altText = 'Image',
    width = '100%', // This is for the image element itself
    // height option from widget config is unused for direct image styling in original logic
    objectFit = 'cover',
    linkUrl,
    openInNewTab = true,
  } = options;

  // CSS custom properties for the image element
  const imageStyleProps = {
    '--image-widget-image-width': width, 
    '--image-widget-object-fit': objectFit,
    // --image-widget-image-height is defaulted to 100% in SCSS to fill container
  };

  const imageElement = (
    <img 
      src={imageUrl} 
      alt={altText} 
      className="image-widget-image"
      style={imageStyleProps} 
    />
  );

  if (linkUrl) {
    const linkProps = {
      href: linkUrl,
      target: openInNewTab ? '_blank' : '_self',
      className: 'image-widget-link' // Class for the link wrapper
      // The container width/height is handled by the class styling (100% of grid cell)
    };
    if (openInNewTab) {
      linkProps.rel = 'noopener noreferrer';
    }

    return (
      <a {...linkProps}>
        {imageElement}
      </a>
    );
  }

  // If no link, wrap the image in a div that can take sizing from the class
  return (
    <div className="image-widget-image-wrapper">
      {imageElement}
    </div>
  );
};

export default new Widget(
  'ImageWidget', 
  'Image Display', 
  'Content', 
  render, 
  options,
  {
    minWidth: 1,
    maxWidth: 12,
    minHeight: 1,
    maxHeight: 12,
    defaultWidth: 4,
    defaultHeight: 2
  }
); 